import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { AppBar, Box, Button, IconButton, Toolbar, Tooltip } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import { useColorMode } from '../theme';

interface NavProps {
  isAdmin: boolean;
}

const tabs = [
  { to: '/', label: 'Browse' },
  { to: '/my-requests', label: 'My Requests' },
];

export function Nav({ isAdmin }: NavProps) {
  const loc = useLocation();
  const { mode, toggle } = useColorMode();
  return (
    <AppBar
      position="sticky"
      color="default"
      elevation={0}
      className={mode === 'dark' ? 'border-b border-white/10' : 'border-b border-black/10'}
    >
      <Toolbar className="gap-6">
        <Link to="/" className="flex items-center gap-3 no-underline">
          {/* Tailwind preflight sets img{height:auto} which overrides the
              height attribute — size via class, never the attribute. */}
          <img
            src={mode === 'dark' ? '/brand/wordmark-white.svg' : '/brand/wordmark-black.svg'}
            alt="Hut 8"
            className="h-12 w-auto"
          />
          <span className="text-sm font-semibold tracking-wide">App Registry</span>
        </Link>
        <Box className="flex gap-1 grow">
          {tabs.map((t) => (
            <Button
              key={t.to}
              component={Link}
              to={t.to}
              color={loc.pathname === t.to ? 'primary' : 'inherit'}
              size="small"
            >
              {t.label}
            </Button>
          ))}
          {isAdmin && (
            <Button
              component={Link}
              to="/admin"
              color={loc.pathname.startsWith('/admin') ? 'primary' : 'inherit'}
              size="small"
            >
              Admin
            </Button>
          )}
        </Box>
        <Tooltip title={mode === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}>
          <IconButton onClick={toggle} size="small" color="inherit" aria-label="toggle color mode">
            {mode === 'light' ? (
              <DarkModeIcon fontSize="small" />
            ) : (
              <LightModeIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
      </Toolbar>
    </AppBar>
  );
}
